(function () {
  var style = document.createElement('style');
  style.textContent = [
    '.kv-wa{position:fixed;bottom:24px;right:24px;z-index:9999;display:flex;align-items:center;gap:10px;text-decoration:none}',
    '.kv-wa__bubble{background:#25D366;color:#fff;font-family:inherit;font-size:13px;font-weight:500;padding:8px 14px;border-radius:20px;white-space:nowrap;box-shadow:0 2px 12px rgba(0,0,0,.18);opacity:0;transform:translateX(8px);transition:opacity .2s,transform .2s;pointer-events:none}',
    '.kv-wa:hover .kv-wa__bubble,.kv-wa:focus .kv-wa__bubble{opacity:1;transform:translateX(0)}',
    '.kv-wa__btn{width:56px;height:56px;border-radius:50%;background:#25D366;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 16px rgba(37,211,102,.45);transition:transform .15s,box-shadow .15s;flex-shrink:0}',
    '.kv-wa__btn:hover{transform:scale(1.08);box-shadow:0 6px 20px rgba(37,211,102,.55)}',
    '.kv-wa__btn svg{width:30px;height:30px}',
    '@keyframes kv-wa-pulse{0%,100%{box-shadow:0 4px 16px rgba(37,211,102,.45)}50%{box-shadow:0 4px 24px rgba(37,211,102,.7)}}',
    '.kv-wa__btn{animation:kv-wa-pulse 2.4s ease-in-out infinite}'
  ].join('');
  document.head.appendChild(style);

  var a = document.createElement('a');
  a.href = 'https://wa.me/33743687071';
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.className = 'kv-wa';
  a.setAttribute('aria-label', 'Nous contacter sur WhatsApp');

  a.innerHTML = [
    '<span class="kv-wa__bubble">Une question ? Écrivez-nous</span>',
    '<div class="kv-wa__btn" aria-hidden="true">',
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#fff">',
    '<path d="M16 2C8.27 2 2 8.27 2 16c0 2.44.65 4.73 1.78 6.72L2 30l7.52-1.74A13.92 13.92 0 0 0 16 30c7.73 0 14-6.27 14-14S23.73 2 16 2zm7.28 19.47c-.3.84-1.77 1.61-2.42 1.67-.62.06-1.2.28-4.05-.84-3.42-1.35-5.6-4.85-5.77-5.08-.16-.22-1.35-1.8-1.35-3.43s.85-2.44 1.17-2.77c.3-.33.66-.41.88-.41l.63.01c.2 0 .47-.08.74.56.28.67.97 2.36.1 2.56l-.54.67c-.17.2-.2.44-.07.7.58 1.06 1.36 2 2.28 2.76 1.04.87 2.1 1.42 2.38 1.57.28.15.44.13.6-.08l.75-.9c.18-.22.47-.28.76-.17 1.7.76 1.73.76 2.04.9.3.14.5.2.57.32.08.44-.13 1.82-.43 2.66z"/>',
    '</svg>',
    '</div>'
  ].join('');

  document.body.appendChild(a);
})();
